function IconMyClasses({ color = 'black', ...restProps }) {
  return (
    <svg
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      width="40px"
      height="40px"
      color={color}
      {...restProps}
    >
      <path d="M90.9,2.8H9.2C4.1,2.8,0,6.9,0,12v76c0,5.1,4.1,9.2,9.2,9.2h81.6c5.1,0,9.2-4.1,9.2-9.2V12C100.1,6.9,96,2.8,90.9,2.8z  M48.9,48.5h2c2.8,0,4.7,0.7,6.1,2.1c1.2,1.3,2,3.2,2.4,5.8l0.1,0.5h-19l0.1-0.5c0.4-2.6,1.1-4.5,2.3-5.7 C44.2,49.2,46.2,48.5,48.9,48.5z M44,33.1c0-4.2,2.8-7.4,6.4-7.4c3.5,0,5.7,3.8,5.7,7.4c0,3.8-2.5,8.2-5.7,8.2 C46.8,41.2,44,37.6,44,33.1z M71.1,62.8v9.7H30v-9.7H71.1z M61.3,78.4V90H39.6V78.4H61.3z M92.8,88c0,1.1-0.9,2-2,2H67.2V78.4h9.9 v-5.7v-0.2v-9.7h6v-5.9h-18L65,56.3c-1-6.3-3.5-10.3-7.6-12.2c2.8-2.6,4.5-6.8,4.5-11c0-7.2-5.1-13.1-11.4-13.1 c-6.8,0-12.1,5.8-12.1,13.1c0,4.3,1.6,8.2,4.5,10.8c-4.2,1.8-6.7,5.8-7.6,12.4l-0.1,0.6H17.9v5.9h6.2v9.7v0.2v5.7h9.6V90H9.2 c-1.1,0-2-0.9-2-2V12c0-1.1,0.9-2,2-2h81.6c1.1,0,2,0.9,2,2V88z" />
    </svg>
  );
}

export default IconMyClasses;
